


































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

export enum ViewType {
  Calendar,
  List
}

export default mixins(Proxyable).extend({
  name: 'TimeOffViewSelector',

  data() {
    return {
      ViewType
    };
  }
});
